import { isHttpUrl } from '../../utils/manualOpportunity';

const isBlank = (value) => !value || !String(value).trim();

export const validateManualOpportunity = (formData, trans) => {
  const errors = {};
  if (isBlank(formData.pursuitName)) errors.pursuitName = trans('required-field');
  if (!formData.opportunityType) errors.opportunityType = trans('required-field');
  if (isBlank(formData.dueDate)) errors.dueDate = trans('required-field');
  if (isBlank(formData.solicitationNumber)) errors.solicitationNumber = trans('required-field');
  if (isBlank(formData.sourceLink)) errors.sourceLink = trans('required-field');
  else if (!isHttpUrl(formData.sourceLink)) errors.sourceLink = trans('enter-valid-url');
  return errors;
};
